/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NB_AUTH_OPTIONS } from '../../auth.options';
import { getDeepFromObject } from '../../helpers';
import { ApiService } from '../../../services/api.service';
import { ChatsService } from '../../../pages/chats/chats.service';


@Component({
  selector: 'nb-logout',
  templateUrl: './logout.component.html',
})
export class NbLogoutComponent implements OnInit {

  redirectDelay: number = 0;
  strategy: string = '';

  constructor(private _apiService: ApiService,private signalR:ChatsService,
    
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected router: Router) {
    this.redirectDelay = this.getConfigValue('forms.logout.redirectDelay');
    this.strategy = this.getConfigValue('forms.logout.strategy');
    localStorage.clear();
    this.signalR.disconnect()
    this._apiService.success('log Out Successfully')
   this.router.navigate(['/auth']);
  }

  ngOnInit(): void {
 
  }
  

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
